import axios from '@/config/axios';

const actions = {
    contact: async (context, params) => {
        try {
            const response = await axios.post('contact-us', params);
            context.commit('errors/setMessage', response.data.message, {root: true});
        } catch (e) {
            context.dispatch('errors/errorResponse', e.response, {root: true});
        }
    },
};

export default {
    namespaced: true,
    actions
};